export class SearchForm {
    constructor() {
        this.searchForm = document.querySelector('.search-store');
        this.searchInput = document.querySelector('.search-store #address');
        this.ini();
    }

    ini() {
        // store locator input fields
        let input = document.getElementById('address');
        let paceAutoComplete = document.querySelector('.pac-container');
        let isPaceAutoCompleteSet = false;

        if(this.searchForm){
            let autocomplete = new google.maps.places.Autocomplete(input, {
                bounds: new google.maps.LatLngBounds(
                    new google.maps.LatLng(51.227741, 6.773456)
                )
            });


            input.addEventListener('keyup', (event)=> {

                if(event.keyCode === 13) {
                    event.preventDefault();
                    event.stopPropagation();
                }

                if(!isPaceAutoCompleteSet && paceAutoComplete) {
                    addPACEventListener();
                }

                if(!paceAutoComplete) {
                    paceAutoComplete = document.querySelector('.pac-container');
                }

            }, {
                capture: true
            });


            let addPACEventListener = ()=> {
                isPaceAutoCompleteSet = true;
                paceAutoComplete.addEventListener('mouseenter', ()=> {
                    input.focus();
                });
            };

            autocomplete.addListener('place_changed', ()=> {
                var place = autocomplete.getPlace();
                if (place.geometry) {
                    document.getElementById('latitude').value = place.geometry.location.lat();
                    document.getElementById('longitude').value = place.geometry.location.lng();
                    this.searchForm.submit();
                }
            });

            this.searchForm.addEventListener('submit', (e)=> {
                e.preventDefault();
                e.stopPropagation();
            });
        }
    }
}
